import { Suspense } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Loader from "@UI/Loader/Loader";
import { useLazyRouteMap } from "@hooks/useLazyRouteMap";
import { PUBLIC_ROUTES } from "@constants/routeConfig";

const UnauthenticatedRoutes = () => {
  const location = useLocation();
  const lazyByPath = useLazyRouteMap(PUBLIC_ROUTES);

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {PUBLIC_ROUTES.map((r) => {
          const Page = lazyByPath[r.path];
          return <Route key={r.path} path={r.path} element={<Page />} />;
        })}
        <Route
          path="*"
          element={
            location.pathname === "/" ? null : (
              <Navigate
                to={`/login?${new URLSearchParams({ returnTo: location.pathname + location.search + location.hash })}`}
                state={{ from: location }}
                replace
              />
            )
          }
        />
      </Routes>
    </Suspense>
  );
};

export default UnauthenticatedRoutes;
